import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemAddButton,
  TableContentItemLabel,
  TableContentItemText,
  TableContentItemBadge,
  TableContentItemCaptions,
  TableContentItemColumn,
} from '../../../../../../components/TableContent';
import { CustomerBlockStatus } from '../../../../../NewApplication/Customer/components/TableItem/components/CustomerBlockStatus';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../ItemTag';

import { ResponsiveItemCustomerProps } from '.';

export const TabletItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  isSelected,
  addCustomerToCart,
  errorTags,
  isLoadingTags,
  refresherTags,
}) => {
  return (
    <TableContent direction="row" {...(isSelected && { bg: 'backgroundlight' })}>
      <VStack space={Spacing['inline.nano']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Text
            color="neutral.darkest"
            variant="semibold"
            fontSize={Typography['fontsize.md']}
            noOfLines={1}>
            {item.name}
          </Text>
          <HStack space={Spacing['inline.nano']}>
            <TableContentItemCaptions icons={mapCaptions(item)} />
            <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
          </HStack>
        </HStack>
        <HStack justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>CPF/CNPJ</TableContentItemLabel>
            <TableContentItemText>{item.cpfCnpjFormatted}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Cadastro</TableContentItemLabel>
            <TableContentItemColumn>
              <CustomerBlockStatus customer={item} />
            </TableContentItemColumn>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Conta</TableContentItemLabel>
            <TableContentItemText>{item.accountNumber}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']} w="150px">
            <TableContentItemLabel>Hashtag</TableContentItemLabel>
            <ItemTag
              data={item.tags}
              itemId={item.customerId}
              errorTags={errorTags}
              isLoadingTags={isLoadingTags}
              refresherTags={refresherTags}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Saldo disponível</TableContentItemLabel>
            <TableContentItemText>{item.availableBalanceFormatted}</TableContentItemText>
          </VStack>
          <TableContentItemAddButton
            isSelected={isSelected}
            isDisabled={item.registrationBlocked}
            addCustomerToCart={addCustomerToCart}
          />
        </HStack>
      </VStack>
    </TableContent>
  );
};
